import { Component, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
//import { LoadingBarService } from '@ngx-loading-bar/core';
import { Router } from '@angular/router';
import { Agency_BranchGroupsProperties } from '../models/Agency_BranchGroupsProperties';
import { DxDataGridComponent } from 'devextreme-angular';
import { Agency_BranchGroupService } from "../Services/agency_branch-group.service";
declare var $;

@Component({
  selector: 'app-agency_branch-group-list',
  templateUrl: './agency_branch-group-list.component.html',
  styleUrls: ['./agency_branch-group-list.component.css']
})
/** Agency_BranchGroupList component*/
export class Agency_BranchGroupListComponent {
  constructor(private groupService: Agency_BranchGroupService, private router: Router) { }
  @ViewChild('revenueGrid', { static: false }) dataGrid: DxDataGridComponent;
  dataList: Agency_BranchGroupsProperties[] = [];
  collapsed = false;

  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };

  ngOnInit() {
    this.LoadAgencyList();
  }
  LoadAgencyList() {
    try {
      this.groupService.GetAllAgencyBranchGroups().subscribe((data) => {
        this.dataList = data;
      });
    }
    catch (e) {
    }
  }

  Edit_Click(groupId) {
    try {
      localStorage.setItem('Agency_BranchGroupListID', groupId);
      this.router.navigateByUrl('/agency_BranchGroups');
    }
    catch (e) { }
  }

  AddNew() {
    try {
      this.router.navigateByUrl('/agency_BranchGroups');
    }
    catch (e) { }

  }
}
